export default __webpack_public_path__ + "static/media/party-blake.9e72395a.jpg";